import { useMemo } from 'react'
import { Navigate, Link } from 'react-router-dom'
import { BanknotesIcon } from '@heroicons/react/24/outline'
import { useAppSelector } from '../hooks/redux'

const FinanceShortcut = () => {
  const { projects, loading } = useAppSelector(state => state.project)

  const financeProjects = useMemo(
    () => projects.filter(p => p.financeEnabled),
    [projects]
  )

  if (loading && projects.length === 0) {
    return (
      <div className="flex items-center justify-center h-64 text-gray-500">
        載入中…
      </div>
    )
  }

  if (financeProjects.length === 0) {
    return (
      <div className="max-w-xl mx-auto mt-12 p-6 bg-white rounded-lg shadow text-center">
        <BanknotesIcon className="mx-auto h-12 w-12 text-gray-400" />
        <h2 className="mt-4 text-lg font-semibold text-gray-900">尚無可用的財務管理專案</h2>
        <p className="mt-2 text-sm text-gray-600">
          目前沒有任何已啟用財務管理的專案，或您沒有對應的存取權限。
        </p>
      </div>
    )
  }

  if (financeProjects.length === 1) {
    return <Navigate to={`/project/${financeProjects[0].key}/finance`} replace />
  }

  return (
    <div className="max-w-2xl mx-auto mt-8 p-6">
      <div className="flex items-center gap-3 mb-6">
        <BanknotesIcon className="h-8 w-8 text-green-600" />
        <h1 className="text-2xl font-bold text-gray-900">財務管理</h1>
      </div>
      <p className="text-sm text-gray-600 mb-4">請選擇要進入的專案：</p>
      <div className="space-y-2">
        {financeProjects.map(project => (
          <Link
            key={project.id}
            to={`/project/${project.key}/finance`}
            className="block p-4 bg-white rounded-lg shadow hover:shadow-md hover:bg-green-50 transition"
          >
            <div className="font-medium text-gray-900">{project.name}</div>
            <div className="text-xs text-gray-500">{project.key}</div>
          </Link>
        ))}
      </div>
    </div>
  )
}

export default FinanceShortcut
